import { createSelector } from 'reselect';
export const getLanguagesList = (state) => state.language.languages || [];
export const getCurrentLanguage = (state) => state.language.currentLanguage || 'en';
export const getLanguageByCode = createSelector([getLanguagesList], (langauges) => (code) => langauges.find((lang) => lang.code === code));
//# sourceMappingURL=language.selector.js.map